import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Tag, Tile } from '@carbon/react';
import { Locked } from '@carbon/react/icons';
import { useBilling } from 'src/hooks/useBilling';

type LockableFeature = 'storefront' | 'zaloOrdering' | 'auditLog';

/**
 * Shows what Pro adds instead of hiding it. Billing off, still loading, or allowed: renders the
 * feature untouched — the server refuses anyway, so a lock that flashes in late costs nothing.
 */
export default function PlanLock({ feature, children }: { feature: LockableFeature; children: React.ReactNode }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data } = useBilling();
  if (!data?.enabled || data.limits[feature]) return <>{children}</>;
  return (
    <Tile className="plan-lock">
      <Tag type="purple" renderIcon={Locked}>
        {t('billing.locked')}
      </Tag>
      <h3>{t(`billing.feature.${feature}`)}</h3>
      <p>{t('billing.upgrade.feature', { feature: t(`billing.feature.${feature}`) })}</p>
      <Button onClick={() => navigate('/settings/organization/billing')}>{t('billing.upgradeToPro')}</Button>
    </Tile>
  );
}
